import Notification from 'flarum/forum/components/Notification';

export default class SarahDailyTipNotification extends Notification {
  icon() {
    return 'fas fa-magic';
  }

  href() {
    return '#';
  }

  content() {
    const data = this.attrs.notification.content() || {};
    return data.summary || '🃏 萨拉的今日建议';
  }

  excerpt() {
    const data = this.attrs.notification.content() || {};
    return data.tip || '';
  }
}
